export default {
  GET_BUSINESS_ACCOUNT: "GET_BUSINESS_ACCOUNT",
};
